import {Typography} from 'components/Typography';
import style from './style.module.scss';
import {FC} from 'react';
import {TastingSlider} from 'modules/events/components/TastingMediaBanner/TastingSlider';

export const TastingMediaBanner: FC = () => {
    return (
        <div className={style.root} data-skeleton-item={true}>
            <Typography variant={'title-20-m'}>Фото и видео с мероприятий</Typography>
            <div className={style.container}>
                <TastingSlider />
            </div>
        </div>
    );
};
